import { hasPermission } from "../../Config/permissions";
export const SHIPPING_STATUSES = ["Shipped", "In Transit", "Delayed", "Delivered"];
export const canManageShipping = (user) =>
  user?.Type === "Admin" && hasPermission(user, "order.manage");
export const canUpdateTracking = (user, row) =>
  canManageShipping(user) &&
  ["DO", "Direct Order"].includes(row?.OrderType) &&
  row?.IsActive !== false &&
  SHIPPING_STATUSES.includes(row?.OrderStatus ?? row?.Status) &&
  Boolean(String(row?.TrackingNumber ?? "").trim());
export const shippingNoteError = (value) => {
  const note = value.trim();
  const hasControl = Array.from(note).some((character) => {
    const code = character.codePointAt(0);
    return (code < 32 && ![9, 10, 13].includes(code)) || code === 127;
  });
  return Array.from(note).length > 2000 || hasControl
    ? "Shipping Note must be at most 2,000 characters without control characters"
    : "";
};

export const createShippingRequestId = () => {
  const crypto = window.crypto;
  if (crypto?.randomUUID) return crypto.randomUUID();
  if (!crypto?.getRandomValues)
    throw new Error(
      "Secure request IDs are unavailable. Open the application over HTTPS.",
    );
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join(
    "",
  );
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};
